module.exports = __webpack_public_path__ + "img/forgotpassword.5d60ab3a.jpg";